<app-container class="auth-container" [noPadding]="handsetService.isXs" fxLayoutAlign="center" maxWidth="516px"
               ngClass.xs="xs">
  <mat-card class="card" fxLayout="column" ngClass.xs="xs">
    <mat-card-header class="header-with-big-space" fxLayout="column" fxLayoutAlign="center center">
      <a class="logo" href="https://payka.pl/">
        <img alt="payka.pl" src="/assets/images/logo-payka/logo_payka.svg" />
      </a>
      <h1>
        Zmień hasło
      </h1>
      <p>
        Aby zmienić hasło, wpisz adres e-mail podany podczas rejestracji. Wyślemy na niego kod weryfikacyjny.
      </p>
    </mat-card-header>
    <form [formGroup]="sendEmailForm">
      <mat-card-content>
        <div ngClass.xs="xs" fxFlex.xs class="container-content">
          <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px">

            <div fxLayout="column" fxLayoutGap="12px">
              <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                <mat-label>Adres e-mail</mat-label>
                <input
                  matInput
                  type="email"
                  [formControl]="email"
                  autocomplete="username"
                  appGtmFormEvent
                  [eventField]="'email'"
                  [eventForm]="formName" />
                <mat-error *ngIf="email.invalid && (email.dirty || !email.untouched)">
                  <ng-container *ngIf="email.errors.required; else pattern">Wpisz adres e-mail</ng-container>
                  <ng-template #pattern>Wpisz prawidłowy adres e-mail</ng-template>
                </mat-error>
              </mat-form-field>

            </div>

            <div class="actions-login" fxLayout="column" fxLayoutAlign="start center">
              <app-new-loader-button
                [disabled]="submitted && !sendEmailForm.valid"
                [loading]="loading"

                (buttonClick)="onSendEmail()" class="auth-button"
                id="login-button"
                [customType]="LoaderButtonType.RAISED"
                color="accent">
                Dalej
              </app-new-loader-button>
            </div>
            <footer fxLayout="row" class="footer">
              <p>
                <a class="h3-regular" [routerLink]="loginUrl"
                   [queryParams]="getQueryParams()">Powrót do logowania</a>
              </p>
            </footer>
          </div>
        </div>


      </mat-card-content>
      <mat-card-actions fxLayout="column" class="flex" style="align-self: center;">
      </mat-card-actions>
      <mat-card-footer>
        <div class="lock" fxLayout="column" fxLayoutAlign="center center">
          <img alt="lock" src="/assets/images/icons/lock.svg" />
        </div>
      </mat-card-footer>
    </form>
  </mat-card>
</app-container>
